
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.92522 8.77555L4.41852 7.81681C3.34749 5.79025 5.54343 3.58646 7.5886 4.66055L8.65641 5.22134C10.5055 6.19244 12.7869 5.25432 13.4099 3.26203L13.76 2.14212C14.4446 -0.047374 17.5554 -0.047375 18.24 2.14212L18.5275 3.06189C19.1498 5.05206 21.4275 5.9908 23.2762 5.02374L24.0418 4.62322C26.0853 3.55431 28.2762 5.75302 27.2103 7.77787L26.7371 8.67684C25.764 10.5254 26.7126 12.7989 28.7097 13.4158L29.8488 13.7677C32.0504 14.4478 32.0504 17.5522 29.8488 18.2323L28.6936 18.5892C26.6944 19.2067 25.7464 21.484 26.7235 23.333L27.1729 24.1832C28.2439 26.2097 26.048 28.4135 24.0028 27.3394L23.286 26.963C21.4369 25.9919 19.1554 26.93 18.5325 28.9223L18.24 29.8579C17.5554 32.0474 14.4446 32.0474 13.76 29.8579L13.415 28.7544C12.7927 26.7642 10.5151 25.8255 8.66638 26.7925L7.54955 27.3767C5.50614 28.4457 3.31518 26.2469 4.38108 24.2221L4.91144 23.2146C5.88452 21.366 4.93589 19.0925 2.93885 18.4756L2.15122 18.2323C-0.0504056 17.5522 -0.050405 14.4478 2.15122 13.7677L2.95518 13.5193C4.95434 12.9018 5.90237 10.6245 4.92522 8.77555Z","stroke":"black","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('circle',{attrs:{"cx":"16","cy":"16","r":"5.5","stroke":"black"}}),_c('circle',{attrs:{"cx":"16","cy":"16","r":"9","stroke":"#0093FF","stroke-width":"2"}})])
          )
        }
      }
    